import styled from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md";
import { motion } from "framer-motion";
import { Link as LinkR } from "react-router-dom";

export const ImageBg = styled.img`
  width: 100%;
  height: 100%;
  background-attachment: fixed;
  background-repeat: no-repeat;
  object-fit: cover;
  /* filter: brightness(0.4); */
`;

export const HeroContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  background-attachment: fixed;
  background-size: cover;
  /* backdrop-filter: brightness(0.4); */
  background-image: url("/spicke.jpg");
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

export const HeroContent = styled(motion.div)`
  z-index: 3;
  position: absolute;
  padding: 8px 60px;
  width: 100%;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 375px) {
    padding: 0 20px;
    margin-top: 50px;
  }
`;

export const HeroH1 = styled(motion.h1)`
  color: #fff;
  font-size: 60px;
  padding-top: -100px;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }
  @media screen and (max-width: 375px) {
    font-size: 25px;
  }
`;

export const HeroP = styled(motion.p)`
  display: none;
`;

export const LinkGroup = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  text-align: center;
  border-radius: 4px;
`;

export const LinkIcon = styled(LinkR)`
  font-size: 32px;
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  padding: 2px;
  align-items: center;
  background: #ffffff92;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: rgba(255, 255, 255, 0.7) 5px 10px 7px;
  }
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 33px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const ArrowForward = styled(MdArrowForward)`
  margin-left: 0;
  font-size: 25px;
  align-items: center;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 0;
  font-size: 25px;
  align-items: center;
`;
